export default "__VITE_ASSET__CTVX$g$K__"